import React from "react"
import DataPath from "@data/menu-options"
import Arrow from "@images/flechaNext.png"
import { Link } from "gatsby-plugin-modal-routing-3"
import { languageUtils } from "@utils/language"
import { utils } from "@utils/utils"

// const getPath = () => {
//   let arr = []
//   const lang = languageUtils.getLanguage()

//   const menuOptions = DataPath[lang]

//   menuOptions.forEach((c, i) => {
//     if (Array.isArray(c.url)) {
//       c.url.forEach((a, i) => {
//         if (!a.ex) arr.push({ url: a.url, title: a.title })
//       })
//     } else {
//       arr.push({ url: c.url, title: c.title })
//     }
//   })

//   let path = typeof window !== "undefined" ? window.location.pathname : lang
//   if (path[path.length - 1] !== "/") path = path + "/"
//   const index = arr.findIndex(i => i.url === path)

//   const link = arr[index + 1]

//   return link
// }

const ChangePageBtn = () => {
  const lang = languageUtils.getLanguage()
  const currentPath = languageUtils.getCurrentPath()

  const nextPageUrl = utils.getNextPage(currentPath)

  // const link = getPath()

  const title = {
    cas: "Ir a apartado siguiente",
    cat: "Anar al següent apartat",
    eng: "Go to the next section",
    eus: "Hurrengo atalera joan",
    gal: "Ir ao apartado seguinte",
  }
  return (
    <>
      {nextPageUrl.popup === true ? (
        <div className="changePage-container">
          <div className="title">{title[lang]}</div>
          <Link className="linkContainer" asModal to={nextPageUrl.url}>
            <div className="pageName">
              {nextPageUrl.name}
              <div className="image">
                <img src={Arrow} alt=""></img>
              </div>
            </div>
          </Link>
        </div>
      ) : (
        <div className="changePage-container">
          <div className="title">{title[lang]}</div>
          <Link className="linkContainer" to={nextPageUrl.url}>
            <div className="pageName">
              {nextPageUrl.name}
              <div className="image">
                <img src={Arrow} alt=""></img>
              </div>
            </div>
          </Link>
        </div>
      )}
    </>
  )
  
}

export default ChangePageBtn
